import angular from 'angular';
import { AiAgentSidebarStateService } from './AiAgentSidebarStateService';
import { AgentSegmentService } from './AgentSegmentService';
import { AgentContextService } from './AgentContextService';
import { FlowVariablesService } from './FlowVariablesService';
import { AgentPromptService } from './AgentPromptService';
import { AiApplicationService } from './AiApplicationService';
import { InstructionJobOrchestratorService } from './InstructionJobOrchestratorService';
import { AgentHandoffService } from './AgentHandoffService';
export const aiAgentServicesModule = angular
    .module('aiAgentServicesModule', [])
    .service('AiAgentSidebarStateService', AiAgentSidebarStateService)
    .service('AgentSegmentService', AgentSegmentService)
    .service('AgentContextService', AgentContextService)
    .service('FlowVariablesService', FlowVariablesService)
    .service('AiApplicationService', AiApplicationService)
    .service('AgentPromptService', AgentPromptService)
    .service('InstructionJobOrchestratorService', InstructionJobOrchestratorService)
    .service('AgentHandoffService', AgentHandoffService)
    .name;
